import moment from "moment";
import React, { useEffect, useState } from "react";
import {
  getBookingDetailById,
  getBookingPdf,
} from "../services/auth/authServices";
import { Col, Row } from "antd";
// import { getBookingDetailById, getBookingPdf } from "../../../services/userservice";

const TravllerBookingDetails = ({ booking_id }) => {
  const [bookingData, setBookingData] = useState(null);
  const [loader, setLoading] = useState(null);

  const fetchBookingData = async () => {
    try {
      setLoading();
      const response = await getBookingDetailById(booking_id);
      if (response?.bookingData) {
        setBookingData(response.bookingData);
      }
    } catch (error) {
      console.error("Error fetching booking data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (booking_id) {
      fetchBookingData();
    }
  }, [booking_id]);

  const generatePdf = async () => {
    setLoading(true);
    try {
      const response = await getBookingPdf(booking_id);
      setLoading(false);
      const file = new Blob([response], { type: "application/pdf" });
      const link = document.createElement("a");
      link.href = URL.createObjectURL(file);
      link.download = "ticket.pdf";
      link.click();
      URL.revokeObjectURL(link.href);
    } catch (error) {
      setLoading(false);
      console.error("Error downloading the PDF:", error);
    }
  };


  const numeric_list = {
    listStyle: "auto",
    borderBottom: "1px solid #ddd",
    marginBottom: "5px",
  };


  return (
    <div className="content-wrapper">
      <section className="content-header">
        <div className="container-fluid">
          <div className="row mb-2">
            <div className="col-sm-6">
              <h1>Booking Detail</h1>
            </div>
          </div>
        </div>
      </section>
      <section className="content">
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="invoice p-3 mb-3">

                <Row gutter={20}>
                  <Col md={12}>
                    <div className=" invoice-col">
                      <div className="smt_invoice_left">
                        {/* From */}
                        <address>
                          <strong>SUPERB WORLD TRIP</strong>
                          <br />
                          SECOND FLOOR NEHRU HOUSE
                          <br />
                          4 BAHADUR SHAH ZAFAR MARG ITO
                          <br />
                          NEW DELHI, INDIA
                          <br />
                          Phone: (+91) 9312241999
                          <br />
                          Email: booking@superbworldtrip.com
                        </address>
                      </div>
                    </div>
                  </Col>
                  <Col md={12}>
                    <h4>
                      {/* <i className="fas fa-globe" /> Superb Infotech Pvt Ltd. */}
                      <small className="float-right">
                        <b>Date:</b>{" "}
                        {moment(bookingData?.booking_date).format("LLLL")}
                      </small>
                    </h4>
                    <h4>
                      {/* <i className="fas fa-globe" /> Superb Infotech Pvt Ltd. */}
                      <small className="float-right">
                        <b>Booking ID:</b>{" "}
                        {bookingData?.smt_booking_id}
                      </small>
                    </h4>
                    {/* <div className="invoice-col smt_invoice_right smt_text_right smt_pt25">
                    <div className="smt_invoice_info smt_mb30">
                      <div className="smt_invoice_seperator smt_gray_bg"></div>
                      <div className="smt_invoice_info_list">
                        <p className="smt_invoice_number">
                          PNR No:{" "}
                          <b className="smt_primary_color">
                            {bookingData?.travelInfos?.[0]?.pnr_number}
                          </b>
                        </p>
                      </div>
                    </div>
                  </div> */}
                  </Col>
                </Row>

                <div className="row">
                  <div className="col-12 table-responsive smt_style1 smt_mb30">
                    <table className="table table-striped ">
                      <thead>
                        <tr>
                          <th>#</th>
                          <th>Passenger Name</th>
                          <th>PNR</th>
                          <th>Ticket Number</th>
                          {/* <th>Frequent Flyer No.</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {bookingData?.passengers.map((passenger, index) => (
                          <tr key={index}>
                            <td className="smt_border_left">{index + 1}</td>
                            <td className="smt_border_left">
                              {passenger?.first_name +
                                " " +
                                passenger?.last_name}
                            </td>
                            <td className="smt_border_left">
                              {bookingData?.travelInfos?.[0]?.pnr_number}
                            </td>
                            <td className="smt_border_left">
                              {passenger?.ticketNumbers?.[0]
                                ? passenger?.ticketNumbers?.[0]
                                : "---"}
                            </td>
                            {/* <td className="smt_border_left">------</td> */}
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <div className="row">
                  <div className="col-12 table-responsive">
                    <table className="table table-striped">
                      <thead>
                        <tr>
                          <th
                            className="smt_width_6 smt_semi_bold smt_primary_color smt_gray_bg"
                            colspan="5"
                          >
                            Flight Information
                          </th>
                        </tr>
                        <tr className="smt_border_top">
                          <th className="smt_width_5 smt_semi_bold smt_primary_color">
                            Flight
                          </th>
                          <th className="smt_width_5 smt_semi_bold smt_primary_color">
                            Departure
                          </th>
                          <th className="smt_width_5 smt_semi_bold smt_primary_color">
                            Arrival
                          </th>
                          <th className="smt_width_5 smt_semi_bold smt_primary_color">
                            Status
                          </th>
                        </tr>
                      </thead>
                      <tbody style={{ backgroundColor: "white" }}>
                        {bookingData?.travelInfos.map((flight, index) => (
                          <tr key={index}>
                            <td style={{ width: "25%" }}>
                              {flight?.airline} {flight?.flightNumber}
                              <br /> Cabin:&nbsp; <b>{flight?.cabin_class}</b>
                            </td>
                            <td
                              className="smt_border_left"
                              style={{ width: "25%" }}
                            >
                              {flight?.departure_city_code} (
                              {flight?.departure_city_airport}
                              <br />
                              {flight?.departure_city_terminal && (
                                <>
                                  <b>Terminal:</b> {flight?.departure_city_terminal}
                                  <br />
                                </>
                              )}
                              <b>
                                {moment
                                  .utc(flight?.departure_time)
                                  .format("LLLL")}
                              </b>
                            </td>
                            <td
                              className="smt_border_left"
                              style={{ width: "25%" }}
                            >
                              {flight?.arrival_city_code} (
                              {flight?.arrival_city_airport})
                              <br />
                              {flight?.arrival_city_terminal && (
                                <>
                                  <b>Terminal:</b> {flight?.arrival_city_terminal}
                                  <br />
                                </>
                              )}
                              <b>
                                {moment
                                  .utc(flight?.arrival_time)
                                  .format("LLLL")}
                              </b>
                            </td>
                            <td
                              className="smt_border_left"
                              style={{
                                width: "25%",
                                color:
                                  bookingData?.order?.status === "CANCELLED"
                                    ? "red"
                                    : "inherit",
                              }}
                            >
                              {/* <b className="">{bookingData?.booking_status}</b> */}
                              {/* <br /> */}
                              <span style={{ whiteSpace: "nowrap" }}>
                                Baggage(per Adult):{" "}
                                <b className="">{flight?.cabin_baggage}</b>
                                <br />
                                Total Excess Baggage:{" "}
                                <b className="">{flight?.baggage}</b>
                                <br />
                                {/* Seat No : <b className="">2F,2E,22E,22F</b> */}
                                <br />
                              </span>
                              {/* Non stop */}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </div>

                <Row gutter={16} className="mt-2">
                  <Col md={14} xs={14}></Col>
                  <Col md={10} xs={10}>
                    <p className="smt_mb3">
                      <b className="smt_primary_color">Payment Details:</b>
                    </p>
                    <table>
                      <tbody>
                        {/* <tr>
                                                    <td className="smt_width_3 smt_primary_color smt_border_none smt_pb5">
                                                        Fare:{" "}
                                                    </td>
                                                    <td className="smt_width_3 smt_primary_color smt_text_right smt_border_none smt_pb5">
                                                        ₹
                                                        {bookingData?.amount}
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="smt_width_3 smt_primary_color smt_border_none smt_pt0 smt_pb5">
                                                        K3/GST:
                                                    </td>
                                                    <td className="smt_width_3 smt_primary_color smt_text_right smt_border_none smt_pt0 smt_pb5">
                                                        ₹
                                                        {
                                                            bookingData?.other_charge ? bookingData?.other_charge : 0.00
                                                        }
                                                    </td>
                                                </tr>
                                                <tr>
                                                    <td className="smt_width_3 smt_primary_color smt_border_none smt_pt0 smt_pb5">
                                                        Fee & Surcharge:{" "}
                                                    </td>
                                                    <td className="smt_width_3 smt_primary_color smt_text_right smt_border_none smt_pt0 smt_pb5">
                                                        ₹0.00
                                                    </td>
                                                </tr> */}

                        <tr className="smt_border_top">
                          <td className="smt_width_3 smt_border_top_0 smt_bold smt_f16 smt_primary_color">
                            Grand Total{" "}
                          </td>
                          <td className="smt_width_3 smt_border_top_0 smt_bold smt_f16 smt_primary_color smt_text_right">
                            ₹{Math.round(bookingData?.total_amount)}
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </Col>
                </Row>

                <div className="row smt_invoice_footer mt-4">
                  <div className="">
                    <p className="mb-2">
                      <b className="smt_primary_color">
                        Terms &amp; Conditions:
                      </b>
                    </p>
                    <ol className="ps-3 mb-3">
                      <li style={numeric_list}>
                        All Passengers, including children and infants, must
                        present valid Photo ID at check-in Counter, e.g Aadhar
                        Card, Voter ID Card, Pan Card or other Government Photo
                        IDs.
                      </li>
                      <li style={numeric_list}>
                        Check-in begains 2 hours prior to the flight and closes
                        45 minutes prior to the scheduled departure for the
                        domestic flights .
                      </li>
                      <li style={numeric_list}>
                        In case of cancellation / changes by passenger, less
                        than 24 hours before departure, please cancel / change
                        with the airlines directly. Airlines terms & conditions
                        applies.
                      </li>
                      <li style={numeric_list}>
                        Any Changes to the reservation will result in the
                        Airline's penalty fee plus differance of fare, if any,
                        and with our service charge of Rs. 300 per passenger per
                        sector.{" "}
                      </li>
                      <li style={numeric_list}>
                        Cancellation of ticket will result in the Airline's fee
                        plus our service charge of Rs. 600 per passenger per
                        sector.
                      </li>
                      <li style={numeric_list}>
                        Convenience fees and surcharges are non-refundable in
                        case of cancellation of flight by Airline or
                        cancellation request made by the passenger.{" "}
                      </li>
                      <li style={numeric_list}>
                        We are not responsible for any delay or Cancellation of
                        Flights by the Airline's Contact the Airline or
                        cancellation request made by the passenger.
                      </li>
                      <li style={numeric_list}>
                        We being a travel agent, all reservations made through
                        our website are as per the terms and conditions of the
                        concerned Airlines. All modifications, cancellations,
                        and refunds are subject to Airline's policy.
                      </li>
                      <li style={numeric_list}>
                        Please do not share your bank or card details like
                        password, CVV, OTP etc. to any third person or party. We
                        never ask for these details. For any query directly on
                        our official email or contact no. printed on this
                        ticket.
                      </li>
                      <li style={numeric_list}>
                        Please confirm from the Airline 2/3 days prior to
                        departure about mandotary requirements of Covid-19
                        protocols like RT-PCR test or vaccination etc. and
                        stricly follow them to avoid any inconvenience at the
                        Airport.{" "}
                      </li>
                    </ol>
                  </div>
                </div>
                <div className="row no-print">
                  <button
                    type="button"
                    className="btn btn-primary"
                    style={{ marginRight: 5 }}
                    onClick={generatePdf}
                    disabled={loader}
                     aria-label="Generate PDF"
                  >
                    <i className="fas fa-download" />{" "}
                    {loader ? "Generating..." : "Generate PDF"}
                  </button>

                  {loader && <span>Please wait ...</span>}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TravllerBookingDetails;
